import Card from "../common/Card";
import Hero from "../common/Hero";
import FollowUs from "../common/Followus";
import Clients from "../common/Clients";
import Features from "../common/Features";
import Stats from "../common/Stats";

function Home() {
    return (
      <div>
          <Hero/>
          <Card/>
          <Features/>
          <Clients/>
          <Stats/>
          <FollowUs/>
      </div>
    )
  }


  export default Home